"use client";

import styled from "styled-components";

export const InputWrapper = styled.div`
  @media only screen and (min-width: 990px) and (max-width: 1439px) {
    display: none;
  }
`;
